import Box from '@mui/material/Box'
import { FC, memo, PropsWithChildren } from 'react'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const CheckboxButtonContainer: FC<
  PropsWithChildren & {
    label: string
    tooltip?: string
  }
> = ({ label, tooltip, children }) => {
  return (
    <Box>
      <Box
        sx={theme => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          border: `1px solid ${theme.palette.primary.main}`,
          borderRadius: 1,
          cursor: 'pointer',
          position: 'relative',
          paddingLeft: 1.5,
          paddingTop: 1.5,
          paddingBottom: 1.5,
          backgroundColor: '#fff',
        })}
      >
        <Box
          sx={{
            paddingBottom: 1.5,
            paddingRight: 1.5,
          }}
        >
          <Typography variant="subtitle2" sx={{ fontSize: 12, lineHeight: '12px' }}>
            {label}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          {children}
        </Box>
        {tooltip && (
          <Box
            sx={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
            }}
          >
            <Tooltip title={tooltip} enterTouchDelay={0} placement="top">
              <InfoOutlinedIcon
                color="primary"
                sx={{ fontSize: 16, backgroundColor: 'white', borderRadius: '50%' }}
              />
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default memo(CheckboxButtonContainer)
